var _style, _path, _linearGradient, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpinnerGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 36 36",
    viewBox: "0 0 36 36",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#8D929E;fill-opacity:0.103;}\n\t.st1{fill:url(#a);}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m27 8.6c0 0.6-0.1 1.2-0.5 1.8-0.5 0.8-1.3 1.2-2.1 1.3 2.9 2.9 3.5 7.5 1.2 11.1l-0.1 0.1c-2.4 3.6-6.9 4.9-10.7 3.4 0.3 0.8 0.2 1.8-0.3 2.6-0.4 0.6-0.9 0.9-1.5 1.2 5.7 2.3 12.4 0.4 15.8-4.9 3.6-5.4 2.6-12.4-1.8-16.6z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 5.8248,
    x2: 21.686,
    y1: 27.003,
    y2: 4.3567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A2E1",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37B376",
    offset: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46C31D",
    offset: 0.68
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m10.9 28.9c0.7 0.4 1.4 0.8 2.1 1.1 0.6-0.2 1.1-0.6 1.5-1.2 0.5-0.8 0.6-1.7 0.3-2.6-0.6-0.2-1.1-0.5-1.6-0.8-4.1-2.7-5.2-8.2-2.5-12.3 2.7-4 8.1-5.2 12.2-2.6l1.5 1.2c0.8-0.1 1.6-0.6 2.1-1.3 0.4-0.5 0.5-1.2 0.5-1.8-0.6-0.5-1.2-1.1-1.9-1.5-6-3.9-14.1-2.2-18 3.8s-2.2 14.1 3.8 18z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerGradient);
export default __webpack_public_path__ + "static/media/spinner-gradient.3134cad9211a9690c4640850f8177dc6.svg";
export { ForwardRef as ReactComponent };